import * as Yup from "yup";

export const ReportLinkSchema = Yup.object({
    reportEmail:Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
});
export const AttachmentSchema = Yup.object({
    attachmentEmail: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
});


export const ReportAndAttachmentSchema = Yup.object({
    reportEmail: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
    attachmentEmail :Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
});